export default "__VITE_ASSET__4CmQCtqo__"